// client/src/coms/views/games_parts/activeGameStore.js
// The game the player is currently in (a hosted GameNest session or a party game), shared between the
// Games view and the Voxemera shell so the shell can keep the game running while another area is open and
// offer a way back to it. Persisted per browser tab, so a reload returns to the same game.
const KEY = 'voxemera:games:active';
const LEGACY_SESSION_KEY = 'voxemera:games:active-session';
const listeners = new Set();

function read() {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && (parsed.kind === 'session' || parsed.kind === 'party' || parsed.kind === 'watch') && parsed.id) {
        return { kind: parsed.kind, id: String(parsed.id), name: String(parsed.name || 'Game'), serverId: String(parsed.serverId || '') };
      }
    }
    // Sessions opened before the shared store existed.
    const legacy = window.sessionStorage.getItem(LEGACY_SESSION_KEY);
    if (legacy) return { kind: 'session', id: legacy, name: 'Game', serverId: '' };
  } catch {}
  return null;
}

let current = typeof window === 'undefined' ? null : read();

export function getActiveGame() {
  return current;
}

export function setActiveGame(next) {
  const value = next && next.id ? { kind: next.kind, id: String(next.id), name: String(next.name || 'Game'), serverId: String(next.serverId || '') } : null;
  if (JSON.stringify(value) === JSON.stringify(current)) return;
  current = value;
  try {
    if (value) window.sessionStorage.setItem(KEY, JSON.stringify(value));
    else window.sessionStorage.removeItem(KEY);
    window.sessionStorage.removeItem(LEGACY_SESSION_KEY);
  } catch {}
  listeners.forEach((listener) => {
    try {
      listener(current);
    } catch {}
  });
}

export function subscribeActiveGame(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// An invitation link (/comms?gameCode=CODE) is read once when the page loads: Voxemera redirects /comms to
// the last server's address, which drops the query before the shell mounts.
let pendingCode = '';
try {
  if (typeof window !== 'undefined') {
    pendingCode = String(new URLSearchParams(window.location.search).get('gameCode') || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 12);
  }
} catch {}

export function peekPendingGameCode() {
  return pendingCode;
}

export function clearPendingGameCode() {
  pendingCode = '';
}
